import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"

const useAutoLogout = (timeout = 4 * 60 * 60 * 1000) => {
  //15 * 60 * 1000 for 15 mins
  const navigate = useNavigate()
  const timerRef = useRef(null)

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      handleLogout()
    }, timeout)
  }

  const handleLogout = () => {
    console.log("User logged out due to inactivity")
    navigate("/login")
  }

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"]

    const resetAndStartTimer = () => resetTimer()

    events.forEach(event => window.addEventListener(event, resetAndStartTimer))

    resetTimer()

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetAndStartTimer),
      )
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return null
}

export default useAutoLogout
